import { render, staticRenderFns } from "./OperationsHistory.vue?vue&type=template&id=2bcc07f8&"
import script from "./OperationsHistory.vue?vue&type=script&lang=ts&"
export * from "./OperationsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./OperationsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports